<div class="flex items-start gap-4">
	<ui-toggle
		[isOn]="isOn()"
		(valueChanged)="onChange($event)"
		[disabled]="disabled()"
		class="mt-1"
	></ui-toggle>
	<div>
		<div class="font-semibold" [class.text-secondary-400]="!isOn()">
			{{ title() | translate }}
		</div>
		<div [class.text-secondary-400]="!isOn()">
			<span [innerHtml]="cookieDescription() | translate"></span>
			<br />
			<span>
				{{ 'cookie.cookies_link' | translate }}
				<a
					class="inline-block !text-primary-800 text-base transition-colors duration-300"
					[href]="'cookie.imprint_link' | translate"
					target="_blank"
					>{{ 'cookie.imprint' | translate }}</a
				>
			</span>
		</div>
	</div>
</div>
